import { IbhFilterKeys } from '@hub/libs/constants';
import type { IbhFilterValues } from '@hub/hooks/states/useIbhFilterValuesStore';
import { useTranslation } from 'next-i18next';
import type { IbhDimensions } from '@hub/bearing-hub/common/dimensions/dimensions';
import type { UnitSystem } from '@icommerce/units';
import { getUnitLabelForUnitSystem, PressureCode } from '@icommerce/units';
import { BasicNumberInput } from '@hub/common/BasicNumberInput/BasicNumberInput';
import { getIcommerceUnitSystemName } from '@hub/bearing-hub/common/useUnitSystem/useUnitSystem';

interface SurfacePressureSectionProps {
  filterValues: IbhFilterValues;
  setFilterValue: (key: IbhFilterKeys, value: string | string[] | number | boolean | undefined | IbhDimensions) => void;
  isCollapsible?: boolean;
  unitSystem: UnitSystem;
}

export const SurfacePressureSection = ({
  setFilterValue,
  filterValues,
  isCollapsible = false,
  unitSystem,
}: SurfacePressureSectionProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);
  const placeholderText = t(`FILTERS.PLACEHOLDER.MAX_SURFACE_PRESSURE`, { ns: 'bearing-hub/bearingHub' });

  return (
    <BasicNumberInput
      id={`filter_${isCollapsible ? 'collapsible_' : ''}${IbhFilterKeys.MAX_SURFACE_PRESSURE}`}
      unit={getUnitLabelForUnitSystem(PressureCode.MEGAPASCAL, getIcommerceUnitSystemName(unitSystem))}
      onChange={newValue => {
        setFilterValue(
          IbhFilterKeys.MAX_SURFACE_PRESSURE,
          !Number.isNaN(parseInt(newValue, 10)) ? parseInt(newValue, 10) : undefined
        );
      }}
      placeholder={placeholderText}
      value={
        (typeof filterValues[IbhFilterKeys.MAX_SURFACE_PRESSURE] !== 'undefined'
          ? `${filterValues[IbhFilterKeys.MAX_SURFACE_PRESSURE] as number}`
          : undefined) || ''
      }
      title={placeholderText}
    />
  );
};
